<script setup>
  import { ref, computed, defineAsyncComponent } from 'vue';
  import { useMediaQuery } from '@/composables/useMediaQuery';
  import { useUserStore } from '@/stores/UserStore';
  import CompleteReportDataContainerSection from '@/components/CompleteReportDataContainerSection.vue';
  import GorgeWindbowUpgradeBlock from '@/components/GorgeWindbowUpgradeBlock.vue';

  const GorgeWindbowContainer = defineAsyncComponent(() => import('@/components/GorgeWindbowContainer.vue')); 

  const props = defineProps({
    upgrade: {
      type: Array,
      required: true
    }
  });

  const userStore = useUserStore();

  const isDesktop = useMediaQuery('(min-width: 840px)');

  const minHeight = computed(() => isDesktop.value ? '716px' : '704px');

  const content = ref(null);
</script>

<template>
    <GorgeWindbowUpgradeBlock
      v-if="userStore.memberLevel < 46"
      :upgrade="props.upgrade"
    />

    <CompleteReportDataContainerSection
      v-else
      v-model:content="content"
      sectionId="gorge-windbow"
      title="Gorge Windbow"
      :metaActions="false"
      :minHeight="minHeight"
    >
      <template #content="{ isVisible }">
        <GorgeWindbowContainer
          v-if="isVisible"
          v-model:content="content"
        />
      </template>
    </CompleteReportDataContainerSection>
</template>